/*
 * @Editor: chenqy
 * @Description:
 * ########################## 平台单击/区别双击指令 ##########################
 * 单击格式：v-click="[函数名,参数1,参数2,...]" / v-click="函数名"
 * 双击格式：v-click:dbl.300="同上" / v-click:dbl="同上")
 * ps: 如果指令没有修饰符默认双击有效时间为500ms
 * ######################################################################
 * @Date: 2023-02-17 16:26:56
 * @LastEditors: Chenqy
 * @LastEditTime: 2023-02-20 16:08:23
 */
class ClickHelper {
  timer = null;
  preClickDate = 0;
  eventMap = {};
  vnodeContext = null;
  bingEvent = null;
  constructor(interval, vnodeContext) {
    // 视为双击的时间差(ms)
    this.interval = interval;
    // 绑定组件上下文
    this.vnodeContext = vnodeContext;
  }
  addEvent(binding, type) {
    const { fn: cb, params } = this.parseExpression(binding.value);
    if (cb) {
      this.eventMap[type] = {
        cb,
        params,
      };
    } else {
      dsf.error(
        `[v-click${
          type === "click" ? "" : ":dbl"
        }]指令语法错误：未找到传入函数。\neg: #### <div v-click="[函数名,参数1,参数2,...]"></div>\n#### <div v-click="函数名"></div>`
      );
    }
  }
  executeClick() {
    this.bingEvent = () => {
      if (this.eventMap.dblclick) {
        if (this.preClickDate === 0) {
          this.preClickDate = +new Date();
          this.timer = setTimeout(() => {
            if (this.eventMap.click) {
              this.eventMap.click.cb.apply(
                this.vnodeContext,
                this.eventMap.click.params
              );
            }
            this.resetState();
          }, this.interval);
        } else {
          const currentDate = +new Date();
          // 双击
          if (currentDate - this.preClickDate < this.interval) {
            if (this.eventMap.dblclick) {
              this.eventMap.dblclick.cb.apply(
                this.vnodeContext,
                this.eventMap.dblclick.params
              );
            }
            this.resetState();
          }
        }
      } else {
        if (this.eventMap.click) {
          this.eventMap.click.cb.apply(
            this.vnodeContext,
            this.eventMap.click.params
          );
        }
      }
    };
    return this.bingEvent;
  }
  resetState() {
    clearTimeout(this.timer);
    this.preClickDate = 0;
  }
  // 校验v-click表达式是否规范
  validate(expression) {
    const reg = /(^\[)([\s\S]*)(\]$)|^[\w$]/;
    return reg.test(expression);
  }
  // 解析表达式
  parseExpression(data) {
    if (dsf.isFunction(data)) {
      return {
        fn: data,
        params: [],
      };
    } else if (dsf.isArray(data)) {
      const fn = data.shift();
      if (dsf.isFunction(fn)) {
        return {
          fn: fn,
          params: data,
        };
      } else {
        return {
          fn: null,
          params: [],
        };
      }
    } else {
      return {
        fn: null,
        params: [],
      };
    }
  }
}
export default {
  install(Vue) {
    const directive = {
      bind: (el, binding, vnode) => {
        const clickType =
          binding.arg === "dbl" ? "dblclick" : binding.arg ? "none" : "click";
        const expression = binding.expression;
        // 有效双击间隔时间
        const intervalTime = !dsf.isEmptyObject(binding.modifiers)
          ? +Object.keys(binding.modifiers)[0]
          : 500;
        if (clickType === "none") {
          dsf.error(
            `[v-click:${binding.arg}]为无效指令;或许你想用的是[v-click:dbl]或者[v-click]`
          );
        } else {
          let clickHelper = null;
          if (el.vClickDirective) {
            clickHelper = el.vClickDirective;
            if (clickType === "dblclick") {
              clickHelper.interval = intervalTime;
            }
          } else {
            clickHelper = new ClickHelper(intervalTime, vnode.context);
            el.vClickDirective = clickHelper;
          }
          // 校验语法
          if (clickHelper.validate(expression)) {
            clickHelper.addEvent(binding, clickType);
            if (!clickHelper.bingEvent) {
              clickHelper.bingEvent = clickHelper.executeClick();
              el.addEventListener("click", clickHelper.bingEvent);
            }
          } else {
            dsf.error(
              `[v-click]指令语法错误。\neg: #### <div v-click="[函数名,参数1,参数2,...]"></div>\n#### <div v-click="函数名"></div>`
            );
          }
        }
      },
      unbind: (el) => {
        el.removeEventListener("click", el.vClickDirective?.bingEvent);
        el.vClickDirective = null;
      },
    };
    Vue.directive("click", directive);
  },
};
